import { render, staticRenderFns } from "./f2g-color-picker.vue?vue&type=template&id=a1465898&scoped=true"
import script from "./f2g-color-picker.vue?vue&type=script&lang=js"
export * from "./f2g-color-picker.vue?vue&type=script&lang=js"
import style0 from "./f2g-color-picker.vue?vue&type=style&index=0&id=a1465898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1465898",
  null
  
)

export default component.exports